import React from 'react';
import { StapleTableHeader, StapleTableRow, StapleTableHeading } from '@insurancemenu/imenu-components-lib';

const EmployerFormsTableHeader: React.FC = () => {
  return (
    <StapleTableHeader>
      <StapleTableRow>
        <StapleTableHeading>Form</StapleTableHeading>
        <StapleTableHeading>Benefit</StapleTableHeading>
        <StapleTableHeading>Status</StapleTableHeading>
        <StapleTableHeading> </StapleTableHeading>
      </StapleTableRow>
    </StapleTableHeader>
  );
};

export default EmployerFormsTableHeader;
